import { getProposalPreview } from 'common/api/preview';

import {
    FETCH_PROPOSAL_DETAILS,
    FETCH_PROPOSAL_DETAILS_SUCCESS,
    FETCH_PROPOSAL_DETAILS_FAILURE,
} from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default (proposalId) => (dispatch) =>
    new Promise((resolve) => {
        dispatch(multiTemplateReviewActions[FETCH_PROPOSAL_DETAILS]());

        return getProposalPreview(proposalId)
            .then((response) => {
                dispatch(
                    multiTemplateReviewActions[FETCH_PROPOSAL_DETAILS_SUCCESS](
                        response.data.data,
                    ),
                );
                resolve(response.data.data);
            })
            .catch((error) =>
                dispatch(
                    multiTemplateReviewActions[FETCH_PROPOSAL_DETAILS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            )
            .finally(resolve);
    });
